(function () {
  'use strict';
  const words = {
    da: ['Vores bestsellers','Populære produkter','Anbefalet til dig','Lignende produkter','Andre har også købt','Vælg muligheder','Læg i kurv','Vis produkt','Udsolgt','Op til','Spar'],
    en: ['Our bestsellers','Trending products','Recommended for you','Similar products','Others also bought','Choose options','Add to cart','View product','Sold out','Up to','Save'],
    de: ['Unsere Bestseller','Beliebte Produkte','Für dich empfohlen','Ähnliche Produkte','Andere kauften auch','Optionen wählen','In den Warenkorb','Produkt ansehen','Ausverkauft','Bis zu','Spare'],
    sv: ['Våra bästsäljare','Populära produkter','Rekommenderat för dig','Liknande produkter','Andra köpte också','Välj alternativ','Lägg i varukorgen','Visa produkt','Slutsåld','Upp till','Spara'],
    fi: ['Suosituimmat tuotteemme','Suositut tuotteet','Suositeltu sinulle','Samankaltaiset tuotteet','Muut ostivat myös','Valitse vaihtoehdot','Lisää ostoskoriin','Näytä tuote','Loppuunmyyty','Jopa','Säästä'],
    fr: ['Nos meilleures ventes','Produits populaires','Recommandé pour vous','Produits similaires','Les clients ont aussi acheté','Choisir les options','Ajouter au panier','Voir le produit','Épuisé',"Jusqu’à",'Économisez'],
    no: ['Våre bestselgere','Populære produkter','Anbefalt for deg','Lignende produkter','Andre kjøpte også','Velg alternativer','Legg i handlekurven','Vis produkt','Utsolgt','Opptil','Spar']
  };
  const bundleCaptions = { da: 'Vælg indhold', en: 'Choose contents', de: 'Inhalt wählen', sv: 'Välj innehåll', fi: 'Valitse sisältö', fr: 'Choisir le contenu', no: 'Velg innhold' };
  function internalFacet(value) {
    return ['etsy (no animal)', 'under 5', 'mest solgte historisk', 'best-selling in history'].includes(String(value).trim().toLocaleLowerCase('da'));
  }
  function zeroProducts(value) {
    return /^0(?:\s|$)/.test(String(value).trim());
  }
  function productView(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const price = Number(product.price_min ?? product.price);
    const maximum = Number(product.price_max ?? price);
    if (!Number.isFinite(price) || price < 0 || !Number.isFinite(maximum)) throw new Error('Invalid market price');
    const minimumVariant = variants.find(variant => Number(variant.price) === price);
    const compare = Number(minimumVariant ? minimumVariant.compare_at_price : product.compare_at_price) || 0;
    let maximumSaving = 0;
    let maximumDiscount = 0;
    for (const variant of variants) {
      const original = Number(variant.compare_at_price);
      const current = Number(variant.price);
      if (original > current && current >= 0) {
        maximumSaving = Math.max(maximumSaving, original - current);
        maximumDiscount = Math.max(maximumDiscount, Math.round((original - current) * 100 / original));
      }
    }
    const requiresConfiguration = product.clerk_configuration_required === true;
    return { price, maximum, compare: !requiresConfiguration && compare > price ? compare : 0, maximumSaving: requiresConfiguration ? 0 : maximumSaving, maximumDiscount: requiresConfiguration ? 0 : maximumDiscount, requiresConfiguration, available: product.available === true };
  }
  function productPath(href, root, origin) {
    const url = new URL(href, origin);
    const match = url.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    return root.replace(/\/?$/, '/') + 'products/' + match[1];
  }
  function contentPath(href, root, origin) {
    const url = new URL(href, origin);
    const family = host => /^(www\.)?nordicanglers\.(com|de|se|fi|fr|eu|no|co\.uk)$/.test(host) || host === 'nordic-anglers.myshopify.com' ? 'nordic' : /^(www\.)?fluer\.(dk|de|se|fi|fr)$/.test(host) || host === 'fluer-dk.myshopify.com' ? 'fluer' : /^(www\.)?billigtfiskegrej\.dk$/.test(host) || host === 'tyf1cn-ii.myshopify.com' ? 'bfg' : null;
    const store = family(new URL(origin).hostname);
    if (!store || family(url.hostname) !== store || !/^https?:$/.test(url.protocol)) return null;
    const match = url.pathname.match(/\/(collections|pages|blogs)\/(.+)/);
    return match ? root.replace(/\/?$/, '/') + match[1] + '/' + match[2] + url.search + url.hash : null;
  }
  function money(cents, locale, currency) {
    return new Intl.NumberFormat(locale === 'no' ? 'nb-NO' : locale, { style: 'currency', currency }).format(cents / 100);
  }
  function marketProduct(data, expectedCurrency, expectedCountry) {
    if (!data || data.currency !== expectedCurrency || data.country !== expectedCountry || !data.product) throw new Error('Product market context does not match the page');
    let product = data.product;
    if (['local', 'remote', 'backorder', 'soldout'].includes(data.stockState)) {
      product = { ...product, available: product.available === true && data.stockState !== 'soldout', clerk_stock_message: typeof data.stockMessage === 'string' ? data.stockMessage.trim() : '' };
    }
    if (data.requiresConfiguration) return { ...product, clerk_configuration_required: true, available: product.available === true && data.bundleAvailable === true };
    return product;
  }
  function actionCaption(original, text) {
    const options = /muligheder|options|Optionen|alternativ|Schnellansicht|Quick view|Valitse vaihtoehdot|Choisir les options|Velg alternativer/i.test(original);
    const soldOut = /Udsolgt|Sold out|Ausverkauft|Slutsåld|Utsolgt|Loppuunmyyty|Épuisé/i.test(original);
    const view = /Se produkt|View product|Produkt ansehen|Visa produkt|Näytä tuote|Voir le produit|Vis produkt/i.test(original);
    return options ? text[5] : soldOut ? text[8] : view ? text[7] : text[6];
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { productView, productPath, contentPath, money, words, bundleCaptions, actionCaption, marketProduct, internalFacet, zeroProducts };
    return;
  }
  const contextNode = document.getElementById('clerk-market-context');
  if (!contextNode) return;
  const context = JSON.parse(contextNode.textContent);
  const locale = context.locale.split('-')[0];
  const text = words[locale] || words.en;
  const bundleCaption = bundleCaptions[locale] || bundleCaptions.en;
  const root = context.root || '/';
  const format = cents => money(cents, locale, context.currency);
  const selector = '.clerk-fluer-recommendation-card, .clerk-recslide-card, .os-grid-product';
  const widgetSelector = '.clerk[data-template], .clerk-omnisearch-partial-overlay, .clerk-omnisearch-overlay';
  const pending = new WeakSet();
  const cache = new Map();
  const queue = [];
  let running = 0;
  let scheduled = false;
  function drain() {
    while (running < 3 && queue.length) {
      const task = queue.shift();
      running += 1;
      task().finally(() => { running -= 1; drain(); });
    }
  }
  function readProduct(path) {
    if (!cache.has(path)) {
      cache.set(path, new Promise((resolve, reject) => {
        queue.push(async () => {
          try {
            let response;
            for (let attempt = 0; attempt < 2; attempt += 1) {
              try {
                response = await fetch(path + '?section_id=clerk-market-product&country=' + encodeURIComponent(context.country), { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(20000) });
                break;
              } catch (error) {
                if (attempt === 1) throw error;
              }
            }
            if (!response.ok) throw new Error('Product unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const node = html.querySelector('[data-clerk-market-product]');
            if (!node) throw new Error('Market product data missing');
            resolve(marketProduct({currency:node.getAttribute('data-currency'),country:node.getAttribute('data-country'),stockState:node.getAttribute('data-stock-state'),stockMessage:node.getAttribute('data-stock-message'),requiresConfiguration:node.getAttribute('data-configurable-bundle') === 'true',bundleAvailable:node.getAttribute('data-bundle-available') === 'true',product:JSON.parse(node.getAttribute('data-product'))}, context.currency, context.country));
          } catch (error) { reject(error); }
        });
        drain();
      }));
    }
    return cache.get(path);
  }
  function labelWidget(widget) {
    const template = widget.getAttribute('data-template') || '';
    let index = /alternatives/.test(template) ? 3 : /others-also-bought/.test(template) ? 4 : /trending/.test(template) ? 1 : /visitor|complementary/.test(template) ? 2 : /popular/.test(template) ? 0 : -1;
    if (index < 0) return;
    widget.querySelectorAll('.clerk-recslide-headline, .clerk-fluer-recommendation-heading').forEach(heading => {
      if (heading.textContent !== text[index]) heading.textContent = text[index];
    });
  }
  function put(parent, className, value) {
    const child = document.createElement('span');
    child.className = className;
    child.textContent = value;
    parent.appendChild(child);
  }
  function localizeLinks(card) {
    card.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const previous = new URL(link.getAttribute('href'), location.origin);
      const path = productPath(previous.href, root, location.origin);
      if (path) link.href = path + previous.search + previous.hash;
    });
    card.querySelectorAll('[data-product-url]').forEach(button => {
      const path = productPath(button.getAttribute('data-product-url'), root, location.origin);
      if (path) button.setAttribute('data-product-url', path);
    });
  }
  async function hydrate(card) {
    const anchor = card.querySelector('a[href*="/products/"]');
    const path = anchor && productPath(anchor.getAttribute('href'), root, location.origin);
    if (!path) { card.classList.remove('clerk-market-pending'); return; }
    try {
      const product = await readProduct(path);
      const view = productView(product);
      if (!view.available) { card.hidden = true; card.style.display = 'none'; return; }
      card.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const previous = new URL(link.getAttribute('href'), location.origin);
        link.href = path + previous.search;
        if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', product.title);
      });
      card.querySelectorAll('[data-product-url]').forEach(button => button.setAttribute('data-product-url', path));
      card.querySelectorAll('.clerk-recslide-title .clerk-recslide-underlined-text, .clerk-fluer-recommendation-card__title, .os-title .os-underlined-text, .clerk-fluer-search-card__title').forEach(title => { title.textContent = product.title; });
      card.querySelectorAll('img').forEach(image => { image.alt = product.title; });
      card.querySelectorAll('.clerk-recslide-product-type, .os-product-type').forEach(type => { if (locale !== 'da') type.hidden = true; });
      const pricing = card.querySelector('.clerk-recslide-pricing, .clerk-fluer-recommendation-card__pricing, .os-pricing');
      const omni = card.classList.contains('os-grid-product');
      const fluerSearch = card.classList.contains('clerk-fluer-search-card');
      const nordic = card.classList.contains('clerk-recslide-card') || omni;
      if (pricing) {
        pricing.replaceChildren();
        const priceClass = omni ? 'os-price' + (fluerSearch ? ' clerk-fluer-search-card__price' : '') : nordic ? 'clerk-recslide-price' : 'clerk-fluer-recommendation-card__price';
        if (view.requiresConfiguration) {
          put(pricing, priceClass, bundleCaption);
        } else if (nordic && view.maximum > view.price) {
          put(pricing, priceClass, format(view.price));
          put(pricing, omni ? 'os-price-range-sep' : 'clerk-recslide-price-range-sep', ' – ');
          put(pricing, priceClass, format(view.maximum));
        } else {
          put(pricing, priceClass + (view.compare ? nordic ? ' clerk-recslide-on-sale-price' : ' clerk-fluer-recommendation-card__price--sale' : ''), format(view.price));
          if (view.compare) put(pricing, omni ? 'os-list-price' + (fluerSearch ? ' clerk-fluer-search-card__list-price' : '') : nordic ? 'clerk-recslide-list-price' : 'clerk-fluer-recommendation-card__list-price', format(view.compare));
        }
      }
      if (product.clerk_stock_message && pricing) {
        let stock = card.querySelector('.clerk-market-stock');
        if (!stock) {
          stock = document.createElement('p');
          stock.className = 'clerk-market-stock';
          pricing.insertAdjacentElement('afterend', stock);
        }
        stock.textContent = product.clerk_stock_message;
      }
      const viewLink = card.querySelector('.os-card__quick-add--link');
      const shell = card.querySelector('.os-card-shell');
      if (viewLink && shell) shell.appendChild(viewLink);
      card.querySelectorAll('.clerk-recslide-badge-save, .clerk-fluer-recommendation-card__badge--sale, .os-badge-save, .clerk-fluer-search-card__badge--sale').forEach(badge => {
        badge.hidden = view.maximumSaving <= 0;
        badge.textContent = text[10] + ' ' + text[9].toLocaleLowerCase(locale) + ' ' + (nordic && !fluerSearch ? format(view.maximumSaving) : view.maximumDiscount + '%');
      });
      card.querySelectorAll('.clerk-recslide-badge-popular').forEach(badge => { badge.textContent = text[1]; });
      if (view.requiresConfiguration) {
        card.querySelectorAll('.clerk-recslide-quick-add, .clerk-fluer-recommendation-card__cta, .os-card__quick-add, .clerk-fluer-search-card__quick-view').forEach(action => {
          const link = document.createElement('a');
          link.className = action.className.replace(/\bos-card__quick-add--soldout\b/g, '').trim();
          link.href = path;
          link.textContent = bundleCaption;
          link.setAttribute('data-clerk-product-id', String(product.id));
          link.setAttribute('aria-label', bundleCaption + ' – ' + product.title);
          action.replaceWith(link);
        });
        card.dataset.clerkConfigurationRequired = 'true';
      }
      card.querySelectorAll('.clerk-recslide-quick-add-label, .clerk-fluer-recommendation-card__cta, .os-card__quick-add-label, .clerk-fluer-search-card__quick-view').forEach(button => {
        const original = button.textContent.trim();
        const caption = view.requiresConfiguration ? bundleCaption : actionCaption(original, text);
        if (button.children.length === 0) button.textContent = caption;
        else button.querySelectorAll('span:not([aria-hidden="true"])').forEach(label => {
          if (label.children.length === 0 && /[\p{L}]/u.test(label.textContent)) label.textContent = caption;
        });
        button.setAttribute('aria-label', caption + ' – ' + product.title);
        button.setAttribute('title', caption + ' – ' + product.title);
      });
      card.dataset.clerkMarketStatus = 'verified';
      card.dataset.clerkMarketCurrency = context.currency;
      if (view.requiresConfiguration) delete card.dataset.clerkMarketPrice;
      else card.dataset.clerkMarketPrice = String(view.price);
      card.classList.remove('clerk-market-pending');
    } catch (error) {
      card.dataset.clerkMarketStatus = 'unavailable';
      card.hidden = true;
      card.style.display = 'none';
    }
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { observer.unobserve(entry.target); hydrate(entry.target); } });
  }, { rootMargin: '300px' });
  function improveSearch(widget) {
    widget.querySelectorAll('.clerk-facet[data-facet="_category_name"], .clerk-facet[data-facet="categories"]').forEach(facet => {
      if (internalFacet(facet.getAttribute('data-value')) && !facet.classList.contains('clerk-facet-selected')) {
        facet.hidden = true;
        facet.style.display = 'none';
      }
    });
    const count = widget.querySelector('.os-products-count');
    if (!count) return;
    const empty = zeroProducts(count.textContent);
    const previous = widget.querySelector('.clerk-market-empty');
    widget.querySelectorAll('.os-facets, .os-facets-toggle').forEach(facets => {
      if (empty) {
        if (!facets.hasAttribute('data-clerk-empty-display')) facets.setAttribute('data-clerk-empty-display', facets.style.display);
        facets.style.display = 'none';
      } else if (facets.hasAttribute('data-clerk-empty-display')) {
        facets.style.display = facets.getAttribute('data-clerk-empty-display');
        facets.removeAttribute('data-clerk-empty-display');
      }
    });
    if (!empty) { if (previous) previous.remove(); return; }
    if (previous) return;
    const captions = {
      da: ['Ingen produkter matcher din søgning', 'Prøv et kortere produktnavn eller et mærke. Du kan også finde grej via menuens kategorier.'],
      en: ['No products match your search', 'Try a shorter product name or a brand. You can also browse the categories in the menu.'],
      de: ['Keine passenden Produkte gefunden', 'Versuche einen kürzeren Produktnamen oder eine Marke. Du kannst auch die Kategorien im Menü nutzen.'],
      sv: ['Inga produkter matchar din sökning', 'Prova ett kortare produktnamn eller ett varumärke. Du kan också använda kategorierna i menyn.'],
      fi: ['Hakua vastaavia tuotteita ei löytynyt', 'Kokeile lyhyempää tuotenimeä tai tuotemerkkiä. Voit myös selata valikon tuoteryhmiä.'],
      fr: ['Aucun produit ne correspond à votre recherche', 'Essayez un nom de produit plus court ou une marque. Vous pouvez aussi parcourir les catégories du menu.'],
      no: ['Ingen produkter passer til søket ditt', 'Prøv et kortere produktnavn eller et merke. Du kan også bruke kategoriene i menyen.']
    };
    const copy = captions[locale] || captions.en;
    const message = document.createElement('section');
    message.className = 'clerk-market-empty';
    message.setAttribute('role', 'status');
    message.style.cssText = 'padding:24px 16px;line-height:1.5;max-width:640px';
    const heading = document.createElement('h2');
    heading.style.cssText = 'font-size:20px;line-height:1.3;margin:0 0 12px';
    heading.textContent = copy[0];
    const guidance = document.createElement('p');
    guidance.textContent = copy[1];
    message.append(heading, guidance);
    count.parentElement.insertAdjacentElement('afterend', message);
  }
  function scan() {
    scheduled = false;
    document.querySelectorAll(widgetSelector).forEach(widget => {
      labelWidget(widget);
      improveSearch(widget);
      widget.querySelectorAll('a[href]').forEach(link => {
        const path = contentPath(link.getAttribute('href'), root, location.origin);
        if (path && link.getAttribute('href') !== path) link.setAttribute('href', path);
      });
      widget.querySelectorAll(selector).forEach(card => {
        localizeLinks(card);
        if (pending.has(card)) return;
        pending.add(card);
        card.classList.add('clerk-market-pending');
        observer.observe(card);
      });
    });
  }
  function scheduleScan() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  }
  new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.nodeType === 1 && mutation.target.closest(widgetSelector) || [...mutation.addedNodes].some(node => node.nodeType === 1 && (node.matches(widgetSelector) || node.querySelector(widgetSelector))))) scheduleScan();
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
